import FundFinder from '../../../components/MutualFundFinder/FundFinder.jsx'
import React, { useState } from 'react'
import './mutualFundFinder.css'

const isInvestor = (location = globalThis.location) => {
  const investorSite =
    location.pathname.split('/')[1] === 'investor' ||
    location.pathname.split('/')[1] === 'investorspa' ||
    location.href.includes('/cti-investor')
  return investorSite
}

const MutualFundFinder = () => {
  const [showFundFinder, setShowFundFinder] = useState(false)
  const handleOnClick = () => {
    const openFundFinder = document.getElementById('open-mutual-fund-finder')
    const heroTextContainer = document.getElementById(
      'homepage-hero-text-container'
    )
    const myFundsWatchList = document.getElementById('fund-watch-list')
    const istudioOpenFundFinder =
      document.getElementById('is-homepage-hero-subscribe-button') || null

    openFundFinder?.classList.add('u-hiddenVisually')

    if (isInvestor()) {
      myFundsWatchList?.classList.add('u-hidden')
    } else {
      heroTextContainer?.classList.add('u-hidden')
    }

    if (istudioOpenFundFinder) {
      istudioOpenFundFinder?.classList.add('u-hiddenVisually')
    }

    setShowFundFinder(true)
  }

  const handleClose = () => {
    const myFundsWatchList = document.getElementById('fund-watch-list')
    const openFundFinder = document.getElementById('open-mutual-fund-finder')
    const heroTextContainer = document.getElementById(
      'homepage-hero-text-container'
    )
    const istudioOpenFundFinder =
      document.getElementById('is-homepage-hero-subscribe-button') || null

    openFundFinder?.classList.remove('u-hiddenVisually')
    heroTextContainer?.classList.remove('u-hidden')
    if (istudioOpenFundFinder) {
      istudioOpenFundFinder?.classList.remove('u-hiddenVisually')
    }

    if (isInvestor()) {
      myFundsWatchList?.classList.remove('u-hidden')
    }
    setShowFundFinder(false)
  }
  return (
    <>
      {!showFundFinder && (
        <div className="mutual-fund-finder-wrapper u-flex u-flexJustifyCenter u-sizeConstrained u-marginVert12gu">
          <button
            className="Button Button--secondary u-sm-sizeFull"
            id="open-mutual-fund-finder"
            data-analytics="cti-home-find-a-product-btn"
            onClick={handleOnClick}
          >
            <span className="adel-material-symbols">search</span> Find a product
          </button>
        </div>
      )}
      {showFundFinder && (
        <div
          id="mutual-fund-finder"
          className="mutual-fund-finder-wrapper u-sizeConstrained u-paddingVert9gu"
        >
          <FundFinder onClose={handleClose} />
        </div>
      )}
    </>
  )
}
export default MutualFundFinder
